@if(!isEmptyObject(json)) {
  @if (!showJson) {
    <div class="d-flex align-content-center flex-wrap">
      <button type="button" [ngbTooltip]="'brapi-sync.buttons.view.metadata' | translate" [openDelay]="800" class="btn btn-sm btn-outline-info" (click)="show()">
        <i class="fa fa-eye"></i>
      </button>
    </div>
  } @else {
    <div class="position-relative">
      @if (json) {
        <div style="max-height: 300px; max-width: 700px; overflow: auto;" class="custom-scroll-style">
          @if (showJson) {
            <ngx-json-viewer [json]="json"></ngx-json-viewer>
          }
        </div>
      } @else {
        None
      }
      <button type="button" [ngbTooltip]="'brapi-sync.buttons.hide.metadata' | translate" [openDelay]="800"
        class="btn btn-sm btn-outline-info position-absolute top-0 end-0 me-2" (click)="hide()">
        <i class="fa fa-eye-slash"></i>
      </button>
    </div>
  }
}




